
import { Dispatch, SetStateAction } from 'react';
import { EnqueueSnackbar, useSnackbar } from 'notistack';
import { t } from 'i18next';

import auth from '../../../core/authorization';

import productionPlanApi from '../../../api/productionPlanApi';

export const fetchCanCreateAnimalAnnouncements = (
    farmGuid: string,
    setCanCreateAnimalAnnouncement: Dispatch<SetStateAction<boolean | null>>,
    enqueueSnackbar: EnqueueSnackbar
) => {
    productionPlanApi
        .farmHasValidProductionPlan(farmGuid)
        .then((response) => {
            if (!response || !response?.Entity) {
                // general error
                enqueueSnackbar(t('AnelmaGeneral:1020'), {
                    variant: 'error',
                });

                setCanCreateAnimalAnnouncement(false);
                return;
            }
            else if (!response.Entity.Valid) {
                // no valid production plan
                enqueueSnackbar(t('AnelmaSolmuErrors:1060'), {
                    variant: 'warning',
                });

                // AN-2573 - Snellman admin user can create announcements anyway
                // but should get a warning
                if (auth.canViewAdminContextSelector) {
                    setCanCreateAnimalAnnouncement(true);
                    return;
                }

                setCanCreateAnimalAnnouncement(false);
                return;
            }

            setCanCreateAnimalAnnouncement(true);
        });
};